<ng-container *transloco="let t">
  <div class="flex min-h-[25rem] w-full flex-col rounded-xl border border-gray-100 bg-white px-4 py-3 shadow-xs">
    <div class="flex items-center justify-between">
      <div class="flex gap-2">
        <div class="text font-semibold tracking-tight text-gray-800">{{ title() }}</div>
        @if (withEventAnnotation()) {
          <div class="flex items-center gap-2">
            <div class="text-sm font-medium text-gray-600">{{ t("dashboard.activity_events") }}</div>
            <IToggle
              [checked]="displayEventAnnotation()"
              (checkedChange)="displayEventAnnotation.set(!!$event)"
              [disabled]="disableEventAnnotation()"
            />
            <app-activity-event-filters
              class="flex-1"
              [displayEventAnnotation]="displayEventAnnotation()"
              [disableEventAnnotation]="disableEventAnnotation()"
              [allEventAnnotationTypes]="allEventAnnotationTypes()"
              [allStrategies]="allStrategies()"
            />
          </div>
        }
      </div>
      <div class="mb-2 flex items-center gap-4 px-4">
        <ng-content select="[chart-actions]"></ng-content>

        @if (withDateAggregation() && !emptyData()) {
          <IDateAggreationSwitchButton (dateAggSelected)="aggregationChange.emit($event)" />
        }
        @if (chartDisplayModes()?.length) {
          <ISwitchButton
            [type]="SwitchButtonType.ICON"
            [options]="chartDisplayModes()!"
            [selected]="selectedChartDisplayMode()"
            [buttonIcons]="['chartPie', 'chartLine']"
            [buttonTooltips]="[t('overview.display_donut_charts'), t('overview.display_line_chart')]"
            (buttonClicked)="displayModeChange.emit($event)"
          />
        }
        @if (closable()) {
          <button iButton variant="ghost" size="icon-sm" (click)="closeClicked.emit()">
            <IIcon name="close" />
          </button>
        }
      </div>
    </div>
    <div class="flex flex-1 justify-center p-2">
      @if (dataLoading()) {
        <div class="flex w-full items-center justify-center">
          <ISpinner withTitle />
        </div>
      } @else if (emptyData()) {
        <div class="flex w-full items-center justify-center rounded-lg border border-dashed border-gray-200">
          <div class="font-medium tracking-tight text-slate-400">No data</div>
        </div>
      } @else {
        <ng-content></ng-content>
      }
    </div>
  </div>
</ng-container>
